export const SUBSCRIPTION_ENDPOINT = `https://prod-42.westus.logic.azure.com:443/workflows/ba207d93a07042c99c130d4fcfb30e76/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=Rlo7tQz-YFtBtggoBqNvw29hMyMvawEwKWCi2DX99VQ`;
export const SUBMISSION_ENDPOINT = `https://prod-35.westus.logic.azure.com:443/workflows/84d82b7ef6fc42f482703f1ad9c87d84/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=80MRv7Z85vMSBRV9CZ1TfGF_y9F0c8g8Jy6bp8rONjE`;
export const API_URL = 'https://things.sitesee.co/data';
export const emptyModal = undefined;
export const heading = '24px';
export const headingTiny = '13px';
export const closeModal = '45px';
export const ctaText = '15px';
export const fakeCtaOpacity = '#505050';
export const hoverOpacity = 'opacity: 0.5';
export const white = '#fff';
export const green = '#a3ffd3';
export const darkGray = '#2f2f2f';
export const uglyGray = '#ddd';
export const paragraphText = '16px';
export const paragraphSize = '16px';
export const blue = '#3b97d2';
export const mediumGray = '#888';
export const lightGray = '#f4f4f4';
export const red = '#e74c3c';
export const ctaPadding = '8px 30px';

export const darkModeBackground = '#000';
export const darkModeWhite = '#ddd';
export const darkModeDarkGray = darkGray;
export const darkModeNiceGray = '#888';
export const darkModeAppleGray = '#242329';
export const darkModeAppleGrayText = '#717171';
export const darkModeCtaHoverBackground = '#141414';
// export const darkModeYellow = '#f4f1d0';


export const primaryCTA = `
    font-size: ${ctaText};
    font-weight: 200;
    text-align: center;
    display: table;
    padding: 8px 30px;
    color: ${white};
    background-color: ${darkGray};
    margin: 30px auto 0 auto;
    border-radius: 3px;
    border: none;
    cursor: pointer;
`;
export const basicCTA = `
    border-bottom: 1px solid ${darkGray};
    cursor: pointer;
`;

// filter colors
export const filter_black = '#444';
export const filter_blue = '#5c95fb';
export const filter_brown = '#d49a76';
export const filter_gray = '#c7c7c7';
export const filter_green = '#49e4cb';
export const filter_orange = '#F4B350';
export const filter_pink = '#FFADAD';
export const filter_purple = '#C9C1FE';
export const filter_red = '#ff816a';
export const filter_white = '#e6e5e5';
export const filter_yellow = '#ffde91';



export const entryWrapStyles = `
    display: table;
    margin: 15px auto 0 auto;
    width: 1040px;
`;



export const headStyles = `
    @font-face {
        font-family: 'compass_rose_cpc';
        src: url("https://d3alngem7je9z2.cloudfront.net/assets/compassrosecpc-light-webfont.eot");
        src: url("https://d3alngem7je9z2.cloudfront.net/assets/compassrosecpc-light-webfont.eot?#iefix") format("embedded-opentype"), url("https://d3alngem7je9z2.cloudfront.net/assets/compassrosecpc-light-webfont.woff2") format("woff2"), url("https://d3alngem7je9z2.cloudfront.net/assets/compassrosecpc-light-webfont.woff") format("woff");
        font-weight: 100;
        font-style: normal;
    }

    @font-face {
        font-family: 'compass_rose_cpc';
        src: url("https://d3alngem7je9z2.cloudfront.net/assets/compassrosecpc-regular-webfont.eot");
        src: url("https://d3alngem7je9z2.cloudfront.net/assets/compassrosecpc-regular-webfont.eot?#iefix") format("embedded-opentype"), url("https://d3alngem7je9z2.cloudfront.net/assets/compassrosecpc-regular-webfont.woff2") format("woff2"), url("https://d3alngem7je9z2.cloudfront.net/assets/compassrosecpc-regular-webfont.woff") format("woff");
        font-weight: 200;
        font-style: normal;
    }

    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    *, h1, h2, h3, h4, h5, h6 {
        font-family: 'compass_rose_cpc', sans-serif;
        font-weight: 100;
        color: ${darkGray};
    }

    html, body {
        width: 100%;
    }

    body {
        background-color: ${white};
    }

    a {
        text-decoration: none;
    }

    a, img {
        border: none;
        outline: none;
    }

    p {
        font-size: ${paragraphSize};
    }

    b {
        font-weight: 200;
    }

    ul li {
        list-style: none;
    }

    button {
        outline: none;
        border: none;
        background: none;
        cursor: pointer;
    }

    input {
        outline: none;
        border-radius: 0;
    }

    input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px $uglyGray inset;
        -webkit-text-fill-color: ${darkGray} !important;
    }

    input[type=text], input[type=submit] {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        font-weight: 200;
    }

    ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
        color: ${darkGray};
        font-weight: 200;
    }

    textarea:focus, input:focus {
        outline: none;
    }

    ::selection {
        color: ${white};
        background: ${blue};
    }

    body, #__next {
        display: flex;
        min-height: 100vh;
        flex-direction: column;
      }

      main {
        flex: 1;
        width: 100%;
        margin: 0 auto;
        -ms-flex: 1 0 auto;
      }
`;
